// extracted by mini-css-extract-plugin
module.exports = {"box":"ScrollBox_box__3qG71"};